import NeedSliderRange from "./NeedSliderRange";
import React, {useEffect, useState} from "react";
import TarifCell from "./cells/TarifCell";
import JaugeCell from "./cells/JaugeCell";
import Needs from "./Needs";
import MandatoryCell from "./cells/MandatoryCell";
import OpticalCell from "./cells/OpticalCell";
import RoutineCareCell from "./cells/RoutineCareCell";
import HospitalizationCell from "./cells/HospitalizationCell";
import DentalCell from "./cells/DentalCell";
import OptionalCell from "./cells/OptionalCell";
import NeedSlider from "./NeedSlider";

const StepTwoForm = (props) => {

    const handleChange = (event) => {
        props.setTarificationChoice(event.target.value);
    };

    useEffect(() => {
        // Reposition de la vue au début du formulaire au changement d'étape
        document.getElementById("devis-sante-title").scrollIntoView({behavior: 'smooth'});
    }, [])

    return (
        <>
            <div className="tw-flex tw-flex-col tw-gap-6">
                <span className="tw-text-h2 tw-text-mutelios-blue">Récapitulatif</span>
                <div className="tw-flex tw-flex-col tw-p-6 tw-bg-mutelios-blue-light tw-gap-8 tw-rounded">
                    { props.mode === 2 && <Needs/>}
                    <div className="tw-flex tw-flex-col tw-gap-6 tw-self-strech">
                        <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-6 tw-self-stretch">
                            {props.mode === 1 ? <>
                                    <NeedSlider
                                        title="Soins courants"
                                        value={props.routineCareValue}
                                        setValue={props.setRoutineCareValue}
                                        handleNeedsChange={props.handleNeedsChange}
                                        max={5}
                                        railColor="white"
                                    />
                                    <NeedSlider
                                        title="Hospitalisation"
                                        value={props.hospitalizationValue}
                                        setValue={props.setHospitalizationValue}
                                        handleNeedsChange={props.handleNeedsChange}
                                        max={5}
                                        railColor="white"
                                    />
                                </>
                                :
                                <><NeedSliderRange
                                    title="Soins courants"
                                    range={props.routineCareRange}
                                    setRange={props.setRoutineCareRange}
                                    handleNeedsChange={props.handleNeedsChange}
                                    railColor="white"
                                />
                                    <NeedSliderRange
                                        title="Hospitalisation"
                                        range={props.hospitalizationRange}
                                        setRange={props.setHospitalizationRange}
                                        handleNeedsChange={props.handleNeedsChange}
                                        railColor="white"
                                    /></>
                            }
                        </div>
                        <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-6 tw-self-stretch">
                            {props.mode === 1 ? <>
                                    <NeedSlider
                                        title="Dentaire"
                                        value={props.dentaryValue}
                                        setValue={props.setDentaryValue}
                                        handleNeedsChange={props.handleNeedsChange}
                                        max={6}
                                        railColor="white"
                                    />
                                    <NeedSlider
                                        title="Optique"
                                        value={props.opticalValue}
                                        setValue={props.setOpticalValue}
                                        handleNeedsChange={props.handleNeedsChange}
                                        max={6}
                                        railColor="white"
                                    />
                                </>
                                :
                                <>
                                    <NeedSliderRange
                                        title="Dentaire"
                                        range={props.dentaryRange}
                                        setRange={props.setDentaryRange}
                                        handleNeedsChange={props.handleNeedsChange}
                                        railColor="white"
                                    />
                                    <NeedSliderRange
                                        title="Optique"
                                        range={props.opticalRange}
                                        setRange={props.setOpticalRange}
                                        handleNeedsChange={props.handleNeedsChange}
                                        railColor="white"
                                    /></>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="tw-flex tw-flex-col tw-gap-6 tw-self-stretch">
                <span className="tw-text-mutelios-blue tw-text-h2">Comparez et choisissez votre offre</span>
                {!props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "LIGHT") && (
                    <span className="tw-text-body-lead tw-text-mutelios-txt-color">Compte tenu de vos choix, aucune solution allégée n’est disponible. Vous pouvez à tout moment faire évoluer à l’aide des curseurs en haut de page</span>
                )}
                {!props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "REINFORCED") && (
                    <span className="tw-text-body-lead tw-text-mutelios-txt-color">Compte tenu de vos choix, aucune solution renforcée n'est disponible. Vous pouvez à tout moment faire évoluer à l'aide des curseurs en haut de page.</span>
                )}
                <div className="tw-flex tw-flex-col tw-gap-2">
                    <label className="tw-text-sm-h5 lg:tw-text-h5">Choix de la tarification</label>
                    <div className="tw-self-stretch">
                    <div className="tw-flex tw-flex-col md:tw-flex-row tw-items-start tw-gap-2">
                            <div className="tw-flex tw-items-center tw-gap-2">
                                <input {...props.register("tarificationChoice")}
                                       checked={props.tarificationChoice === "tarificationChoice1"}
                                       onChange={handleChange}
                                       id="tarificationChoice1" value="tarificationChoice1" type="radio"/>
                                <label htmlFor="tarificationChoice1">Isolé/famille</label>
                            </div>
                            {props.devisType === "EMP" ? (<div className="tw-flex tw-items-center tw-gap-2">
                                <input {...props.register("tarificationChoice")}
                                       checked={props.tarificationChoice === "tarificationChoice3"}
                                       onChange={handleChange}
                                       id="tarificationChoice3" value="tarificationChoice3" type="radio"/>
                                <label htmlFor="tarificationChoice3">Adulte/enfant</label>
                            </div>) : (<div className="tw-flex tw-items-center tw-gap-2">
                                <input {...props.register("tarificationChoice")}
                                       checked={props.tarificationChoice === "tarificationChoice2"}
                                       onChange={handleChange}
                                       id="tarificationChoice2" value="tarificationChoice2" type="radio"/>
                                <label htmlFor="tarificationChoice2">Uniforme</label>
                            </div>)}
                        </div>
                    </div>
                </div>
            </div>
            <div className="tw-hidden lg:tw-flex tw-items-start tw-self-stretch">
                <div
                    className="tw-flex-1 tw-flex tw-flex-col tw-items-start tw-border-x tw-border-t tw-border-solid tw-border-mutelios-blue-light">
                    <div
                        className="tw-flex tw-h-[54px] tw-p-3 tw-flex-col tw-justify-center tw-items-center tw-gap-2 tw-self-stretch tw-border-b tw-border-solid tw-border-mutelios-blue-light"></div>
                    <MandatoryCell/>
                    {props.mode === 2 && <OptionalCell/>}
                    <RoutineCareCell/>
                    <HospitalizationCell/>
                    <DentalCell/>
                    <OpticalCell/>
                </div>
                <div
                    className="tw-flex-1 tw-flex tw-flex-col tw-items-start tw-border-t tw-border-solid tw-border-mutelios-blue">
                    <div
                        className="tw-flex tw-bg-mutelios-blue tw-h-[54px] tw-p-3 tw-flex-col tw-justify-center tw-items-center tw-gap-2 tw-self-stretch">
                        <span className="tw-text-white tw-text-body-lead-bold">Solution allégée</span>
                    </div>
                    <TarifCell
                        healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "LIGHT")}
                        tarifChoice={props.tarificationChoice}
                        optional={false}
                    />
                    {props.mode === 2 && <TarifCell
                        healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "LIGHT")}
                        tarifChoice={props.tarificationChoice}
                        optional={true}
                    />}

                    <JaugeCell
                        healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "LIGHT")}
                        healthType="routineCare"
                    />
                    <JaugeCell
                        healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "LIGHT")}
                        healthType="hospitalization"
                    />
                    <JaugeCell
                        healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "LIGHT")}
                        healthType="dental"
                    />
                    <JaugeCell
                        healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "LIGHT")}
                        healthType="optical"
                    />
                </div>
                <div
                    className="tw-flex-1 tw-flex tw-flex-col tw-items-start tw-border-[3px] tw-border-solid tw-border-mutelios-blue-btn-hover">
                    <div
                        className="tw-flex tw-bg-mutelios-blue-btn-hover tw-h-[54px] tw-p-3 tw-flex-col tw-justify-center tw-items-center tw-gap-2 tw-self-stretch">
                        <span className="tw-text-white tw-text-body-lead-bold">Solution conseillée</span>
                    </div>
                    <TarifCell
                        healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "WANTED")}
                        tarifChoice={props.tarificationChoice}
                        optional={false}
                    />
                    {props.mode === 2 &&
                        <TarifCell
                            healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "WANTED")}
                            tarifChoice={props.tarificationChoice}
                            optional={true}
                        />
                    }
                    <JaugeCell
                        healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "WANTED")}
                        healthType="routineCare"
                    />
                    <JaugeCell
                        healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "WANTED")}
                        healthType="hospitalization"
                    />
                    <JaugeCell
                        healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "WANTED")}
                        healthType="dental"
                    />
                    <JaugeCell
                        healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "WANTED")}
                        healthType="optical"
                    />
                </div>
                <div
                    className="tw-flex-1 tw-flex tw-flex-col tw-items-start tw-border-r tw-border-solid tw-border-mutelios-blue-light">
                    <div
                        className="tw-flex tw-bg-mutelios-blue tw-h-[54px] tw-p-3 tw-flex-col tw-justify-center tw-items-center tw-gap-2 tw-self-stretch">
                        <span className="tw-text-white tw-text-body-lead-bold">Solution renforcée</span>
                    </div>
                    <TarifCell
                        healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "REINFORCED")}
                        tarifChoice={props.tarificationChoice}
                        optional={false}
                    />
                    {props.mode === 2 &&
                        <TarifCell
                            healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "REINFORCED")}
                            tarifChoice={props.tarificationChoice}
                            optional={true}
                        />
                    }
                    <JaugeCell
                        healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "REINFORCED")}
                        healthType="routineCare"
                    />
                    <JaugeCell
                        healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "REINFORCED")}
                        healthType="hospitalization"
                    />
                    <JaugeCell
                        healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "REINFORCED")}
                        healthType="dental"
                    />
                    <JaugeCell
                        healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "REINFORCED")}
                        healthType="optical"
                    />
                </div>
            </div>
            <div className="tw-overflow-x-auto">
                <div className="lg:tw-hidden tw-flex tw-items-start tw-self-stretch tw-w-[841px]">
                    <div
                        className="tw-flex-1 tw-flex tw-flex-col tw-items-start tw-border-[3px] tw-border-solid tw-border-mutelios-blue-btn-hover">
                        <div
                            className="tw-flex tw-bg-mutelios-blue-btn-hover tw-h-[54px] tw-p-3 tw-flex-col tw-justify-center tw-items-center tw-gap-2 tw-self-stretch">
                            <span className="tw-text-white tw-text-body-lead-bold">Solution conseillée</span>
                        </div>
                        <MandatoryCell/>
                        <TarifCell
                            healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "WANTED")}
                            tarifChoice={props.tarificationChoice}
                            optional={false}
                        />
                        {props.mode === 2 && <OptionalCell/>}
                        {props.mode === 2 &&
                            <TarifCell
                                healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "WANTED")}
                                tarifChoice={props.tarificationChoice}
                                optional={true}
                            />
                        }
                        <RoutineCareCell/>
                        <JaugeCell
                            healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "WANTED")}
                            healthType="routineCare"
                        />
                        <HospitalizationCell/>
                        <JaugeCell
                            healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "WANTED")}
                            healthType="hospitalization"
                        />
                        <DentalCell/>
                        <JaugeCell
                            healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "WANTED")}
                            healthType="dental"
                        />
                        <OpticalCell/>
                        <JaugeCell
                            healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "WANTED")}
                            healthType="optical"
                        />
                    </div>
                    <div
                        className="tw-flex-1 tw-flex tw-flex-col tw-items-start tw-border-t">
                        <div
                            className="tw-flex tw-bg-mutelios-blue tw-h-[54px] tw-p-3 tw-flex-col tw-justify-center tw-items-center tw-gap-2 tw-self-stretch">
                            <span className="tw-text-white tw-text-body-lead-bold">Solution allégée</span>
                        </div>
                        <MandatoryCell/>
                        <TarifCell
                            healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "LIGHT")}
                            tarifChoice={props.tarificationChoice}
                            optional={false}
                        />
                        {props.mode === 2 && <OptionalCell/>}
                        {props.mode === 2 && <TarifCell
                            healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "LIGHT")}
                            tarifChoice={props.tarificationChoice}
                            optional={true}
                        />
                        }
                        <RoutineCareCell/>
                        <JaugeCell
                            healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "LIGHT")}
                            healthType="routineCare"
                        />
                        <HospitalizationCell/>
                        <JaugeCell
                            healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "LIGHT")}
                            healthType="hospitalization"
                        />
                        <DentalCell/>
                        <JaugeCell
                            healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "LIGHT")}
                            healthType="dental"
                        />
                        <OpticalCell/>
                        <JaugeCell
                            healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "LIGHT")}
                            healthType="optical"
                        />
                    </div>
                    <div
                        className="tw-flex-1 tw-flex tw-flex-col tw-items-start tw-border-t tw-border-x tw-border-solid tw-border-mutelios-blue-light">
                        <div
                            className="tw-flex tw-bg-mutelios-blue tw-h-[54px] tw-p-3 tw-flex-col tw-justify-center tw-items-center tw-gap-2 tw-self-stretch">
                            <span className="tw-text-white tw-text-body-lead-bold">Solution renforcée</span>
                        </div>
                        <MandatoryCell/>
                        <TarifCell
                            healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "REINFORCED")}
                            tarifChoice={props.tarificationChoice}
                            optional={false}
                        />
                        {props.mode === 2 && <OptionalCell/>}
                        {props.mode === 2 && <TarifCell
                            healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "REINFORCED")}
                            tarifChoice={props.tarificationChoice}
                            optional={true}
                        />
                        }
                        <RoutineCareCell/>
                        <JaugeCell
                            healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "REINFORCED")}
                            healthType="routineCare"
                        />
                        <HospitalizationCell/>
                        <JaugeCell
                            healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "REINFORCED")}
                            healthType="hospitalization"
                        />
                        <DentalCell/>
                        <JaugeCell
                            healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "REINFORCED")}
                            healthType="dental"
                        />
                        <OpticalCell/>
                        <JaugeCell
                            healthGuarantees={props.tarif?.healthGuarantees?.find(tar => tar.guaranteeType === "REINFORCED")}
                            healthType="optical"
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default StepTwoForm;
